import React from 'react';
import * as styles from './Buttons.module.scss';

interface ButtonsProps {
  children: React.ReactNode;
}

const Buttons = ({ children = null }: ButtonsProps) =>
  children ? <div className={styles.buttons}>{children}</div> : null;

export default Buttons;
